(() => {
  const desktopMedia = window.matchMedia('(min-width: 1200px)');
  const tabletMedia = window.matchMedia('(min-width: 750px) and (max-width: 1199px)');
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  const dialog = document.querySelector('[data-yx-size-guide-dialog]');
  if (!dialog) return;
  const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');

  const table = dialog.querySelector('[data-yx-size-guide-table]');
  const tableScroll = dialog.querySelector('[data-yx-size-guide-table-scroll]');
  const tableHead = dialog.querySelector('[data-yx-size-guide-head]');
  const tableBody = dialog.querySelector('[data-yx-size-guide-body]');
  const unavailable = dialog.querySelector('[data-yx-size-guide-unavailable]');
  const illustration = dialog.querySelector('[data-yx-size-guide-illustration]');
  const illustrationImage = dialog.querySelector('[data-yx-size-guide-image]');
  const pantsGuideIds = new Set([
    'SG-10',
    'SG-11',
    'SG-12',
    'SG-13',
    'SG-14',
    'SG-15',
    'SG-16',
    'SG-17',
    'SG-24',
    'SG-25',
    'SG-26',
    'SG-30',
    'SG-38',
    'SG-41',
  ]);
  const bibOverallsGuideIds = new Set(['SG-18', 'SG-19', 'SG-20', 'SG-21']);
  const topsGuideIds = new Set(['SG-22', 'SG-27', 'SG-28', 'SG-29']);
  const vestsGuideIds = new Set(['SG-08', 'SG-09']);
  const jacketsGuideIds = new Set(['SG-01', 'SG-02', 'SG-03', 'SG-04', 'SG-05', 'SG-06', 'SG-07', 'SG-37', 'SG-39', 'SG-40']);
  const rainSuitGuideIds = new Set(['SG-23']);
  let catalogPromise = null;

  let opener = null;

  const isSupportedViewport = () => desktopMedia.matches || tabletMedia.matches || mobileMedia.matches;

  const syncTrigger = (trigger, isSupported) => {
    if (isSupported) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    } else {
      trigger.removeAttribute('aria-haspopup');
      trigger.removeAttribute('aria-controls');
    }
  };

  const syncQuickBuyTrigger = (trigger, isSupported) => {
    trigger.disabled = !isSupported;
    trigger.setAttribute('aria-hidden', String(!isSupported));
    trigger.tabIndex = isSupported ? 0 : -1;
  };

  const syncTriggerAccessibility = () => {
    const isSupported = isSupportedViewport();

    document.querySelectorAll('[data-yx-size-guide-trigger]').forEach((trigger) => {
      syncTrigger(trigger, isSupported);
    });

    document.querySelectorAll('[data-yx-quick-buy-size-chart-trigger]').forEach((trigger) => {
      syncQuickBuyTrigger(trigger, isSupported);
    });
  };

  const syncAddedTriggers = (node) => {
    if (!(node instanceof Element)) return;
    const isSupported = isSupportedViewport();
    const triggers = [];
    if (node.matches('[data-yx-size-guide-trigger]')) triggers.push(node);
    triggers.push(...node.querySelectorAll('[data-yx-size-guide-trigger]'));
    triggers.forEach((trigger) => {
      syncTrigger(trigger, isSupported);
      if (trigger.matches('[data-yx-quick-buy-size-chart-trigger]')) {
        syncQuickBuyTrigger(trigger, isSupported);
      }
    });
  };

  const close = () => {
    if (dialog.open) dialog.close();
  };

  const readEmbeddedGuide = (trigger) => {
    const scope = trigger.closest('[data-yx-size-guide-scope]');
    const source = scope?.querySelector('[data-yx-size-guide-data]');
    if (!source) return null;

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.warn('YURINOX size guide data could not be parsed.', error);
      return null;
    }
  };

  const readVariantSizes = (trigger) => {
    const scope = trigger.closest('[data-yx-size-guide-scope]');
    const source = scope?.querySelector('[data-yx-size-guide-variant-sizes]');
    if (!source) return [];
    try {
      const sizes = JSON.parse(source.textContent);
      return Array.isArray(sizes) ? sizes.filter((size) => typeof size === 'string' && size.trim()) : [];
    } catch (error) {
      console.warn('YURINOX size option data could not be parsed.', error);
      return [];
    }
  };

  const sizeKey = (size) => String(size || '').trim()
    .replace(/^М$/, 'M')
    .replace(/\bAlto\b/i, 'Tall')
    .replace(/\bExtra Tall\b/i, 'Tall')
    .replace(/^XXL\b/i, '2XL')
    .replace(/\s*[×x]\s*/g, ' × ');

  // EAPU03's manufacturer chart uses letter sizes; its nine current Shopify
  // variants use nominal waist/inseam codes. The chart's flat waist ranges
  // (doubled) confirm this exact one-to-one correspondence.
  const eapu03Sizes = {
    '30W × 29L': 'XS',
    '32W × 30L': 'S',
    '34W × 30L': 'M',
    '36W × 30L': 'L',
    '38W × 32L': 'XL',
    '40W × 32L': 'XXL',
    '42W × 32L': '3XL',
    '44W × 32L': '4XL',
    '46W × 32L': '5XL',
  };

  const shiftedSpectrHandles = new Set([
    'yurinox-spectr-premium-mens-heavy-duty-enhanced-visibility-vest',
    'unionworkwear-spectr-1-mens-enhanced-visibility-work-vest',
    'unionworkwear-spectr-2-mens-adjustable-enhanced-visibility-vest',
  ]);
  const shiftedSpectrSizes = { M: 'L', L: 'XL', XL: '2XL', '2XL': '3XL', '3XL': '4XL' };

  const alignInsulatedSpectr = (guide, sizes, productHandle) => {
    if (productHandle !== 'yurinox-spectr-mens-insulated-enhanced-visibility-work-vest' || guide.gridId !== 'SG-08' || guide.rows.length !== 5 || sizes.length !== 6) return null;
    const current = new Map(sizes.map((size) => [sizeKey(size), size]));
    if (current.size !== 6 || ['M', 'L', 'XL', '2XL', '3XL', '4XL'].some((size) => !current.has(size))) return null;
    const rows = guide.rows.map((row) => ({ ...row, size: current.get(sizeKey(row.size)) }));
    if (rows.some((row) => !row.size)) return null;
    // Estimated from the median of the last three SG-08 size steps; keep
    // the shared source guide unchanged because other vests use it too.
    rows.push({ ...rows[4], size: current.get('4XL'), chest: '51–51.9', waist: '45.6–47.2', hips: '49.2–50.4' });
    return { ...guide, rows };
  };

  const alignShiftedSpectr = (guide, sizes, productHandle) => {
    if (!shiftedSpectrHandles.has(productHandle) || guide.gridId !== 'SG-08' || guide.rows.length !== 5 || sizes.length !== 5) return null;
    const current = new Map(sizes.map((size) => [sizeKey(size), size]));
    if (current.size !== 5 || guide.rows.some((row) => !current.has(shiftedSpectrSizes[sizeKey(row.size)]))) return null;
    // These three owner-approved vests keep their source measurements; the
    // other products sharing SG-08 are untouched.
    return { ...guide, rows: guide.rows.map((row) => ({ ...row, size: current.get(shiftedSpectrSizes[sizeKey(row.size)]) })) };
  };

  const alignStatusBibDraft = (guide, sizes, productHandle) => {
    if (productHandle !== 'unionworkwear-status-mens-shrink-resistant-work-bib-overalls' || guide.gridId !== 'SG-20' || guide.rows.length !== 11 || sizes.length !== 12) return null;
    const source = ['31W × 31L', '34W × 30L', '34W × 33L', '37W × 30L', '37W × 33L', '41W × 30L', '41W × 32L', '44W × 29L', '44W × 32L', '47W × 29L', '47W × 31L'];
    const target = ['30W × 30L', '34W × 30L', '34W × 34L', '36W × 30L', '36W × 34L', '40W × 30L', '40W × 34L', '42W × 30L', '42W × 32L', '46W × 30L', '46W × 32L'];
    if (guide.rows.some((row, index) => sizeKey(row.size) !== source[index])) return null;
    const current = new Map(sizes.map((size) => [sizeKey(size), size]));
    if (current.size !== 12 || [...target, '32W × 30L'].some((size) => !current.has(size))) return null;
    const rows = guide.rows.map((row, index) => ({ ...row, size: current.get(target[index]) }));
    // Owner approved this provisional interpolation for release on 2026-09-23;
    // the source image has no 32W × 30L row, so manufacturer verification remains open.
    rows.splice(1, 0, { ...guide.rows[0], size: current.get('32W × 30L'), waist: '31.5–33', hips: '38.4–39.8', thigh: '20.9–21.7', inseam: '31.8', estimated: true });
    return { ...guide, rows };
  };

  const alignGenesisBib = (guide, sizes, productHandle) => {
    if (productHandle !== 'yurinox-genesis-mens-stain-resistant-utility-work-bib-overalls' || guide.gridId !== 'SG-19' || guide.rows.length !== 11 || sizes.length !== 10) return null;
    const source = ['31W × 32L', '34W × 31L', '34W × 34L', '37W × 31L', '37W × 34L', '41W × 31L', '41W × 33L', '44W × 30L', '44W × 31L', '47W × 30L', '47W × 33L'];
    const target = ['30W × 30L', '32W × 30L', '32W × 32L', '34W × 30L', '34W × 32L', '38W × 30L', '38W × 32L', null, '40W × 32L', '44W × 30L', '44W × 32L'];
    if (guide.rows.some((row, index) => sizeKey(row.size) !== source[index])) return null;
    const current = new Map(sizes.map((size) => [sizeKey(size), size]));
    if (current.size !== 10 || target.some((size) => size && !current.has(size))) return null;
    // Owner-approved mapping: the 44W × 30L source row has no matching variant.
    // Leave the source metaobject intact; omit that row only for this product's display.
    return { ...guide, rows: guide.rows.flatMap((row, index) => target[index] ? [{ ...row, size: current.get(target[index]) }] : []) };
  };

  const alignWorkmaxPants = (guide, sizes, productHandle) => {
    if (productHandle !== 'workmax-mens-water-resistant-softshell-double-knee-work-pants' || guide.gridId !== 'SG-15' || guide.rows.length !== 10 || sizes.length !== 5) return null;
    const source = ['31W × 29L', '31W × 32L', '34W × 30L', '34W × 32L', '37W × 30L', '37W × 33L', '41W × 31L', '41W × 33L', '44W × 31L', '44W × 34L'];
    const target = ['30W × 32L', '32W × 32L', '34W × 32L', '38W × 32L', '42W × 32L'];
    if (guide.rows.some((row, index) => sizeKey(row.size) !== source[index])) return null;
    const current = new Map(sizes.map((size) => [sizeKey(size), size]));
    if (current.size !== 5 || target.some((size) => !current.has(size))) return null;
    // Owner-selected long-inseam rows; other source measurements remain intact.
    return { ...guide, rows: [1, 3, 5, 7, 9].map((index, targetIndex) => ({ ...guide.rows[index], size: current.get(target[targetIndex]) })) };
  };

  const numericGuideIds = new Set(['SG-10', 'SG-11', 'SG-12', 'SG-13', 'SG-14', 'SG-16', 'SG-17', 'SG-18', 'SG-21', 'SG-25', 'SG-41']);
  const firstNumber = (value) => Number(String(value || '').match(/\d+(?:\.\d+)?/)?.[0]);

  const alignNumericGuide = (guide, sizes) => {
    if (!numericGuideIds.has(guide.gridId) || guide.rows.length !== sizes.length) return null;
    const shorts = guide.gridId === 'SG-17';
    const sourceGroups = new Map();
    const variantGroups = new Map();

    guide.rows.forEach((row) => {
      const waist = firstNumber(row.size);
      if (!sourceGroups.has(waist)) sourceGroups.set(waist, []);
      sourceGroups.get(waist).push(row);
    });
    sizes.forEach((size) => {
      const match = sizeKey(size).match(shorts ? /^(\d+)W(?: (Tall))?$/ : /^(\d+)W × (\d+)L$/);
      if (!match) return;
      const waist = Number(match[1]);
      if (!variantGroups.has(waist)) variantGroups.set(waist, []);
      variantGroups.get(waist).push({ size, length: shorts ? Number(Boolean(match[2])) : Number(match[2]) });
    });

    const source = [...sourceGroups.values()].sort((a, b) => firstNumber(a[0].waist) - firstNumber(b[0].waist));
    const variants = [...variantGroups.entries()].sort((a, b) => a[0] - b[0]).map(([, items]) => items);
    if (source.length !== variants.length || variants.flat().length !== sizes.length) return null;

    const assigned = new Map();
    for (let index = 0; index < source.length; index += 1) {
      const rows = [...source[index]].sort((a, b) => firstNumber(a.inseam) - firstNumber(b.inseam));
      const options = [...variants[index]].sort((a, b) => a.length - b.length);
      if (rows.length !== options.length || !Number.isFinite(firstNumber(rows[0].waist))) return null;
      if (rows.some((row, position) => !Number.isFinite(firstNumber(row.inseam)) || (position > 0 && firstNumber(row.inseam) <= firstNumber(rows[position - 1].inseam)))) return null;
      if (options.some((option, position) => position > 0 && option.length <= options[position - 1].length)) return null;
      rows.forEach((row, position) => assigned.set(row, options[position].size));
    }
    return { ...guide, rows: guide.rows.map((row) => ({ ...row, size: assigned.get(row) })) };
  };

  const alignGuideToVariants = (guide, sizes, productHandle) => {
    if (!guide || !sizes.length || !Array.isArray(guide.rows) || !guide.rows.length) return guide;
    const shiftedSpectrGuide = alignShiftedSpectr(guide, sizes, productHandle);
    if (shiftedSpectrGuide) return shiftedSpectrGuide;
    const insulatedSpectrGuide = alignInsulatedSpectr(guide, sizes, productHandle);
    if (insulatedSpectrGuide) return insulatedSpectrGuide;
    const statusBibDraft = alignStatusBibDraft(guide, sizes, productHandle);
    if (statusBibDraft) return statusBibDraft;
    const genesisBib = alignGenesisBib(guide, sizes, productHandle);
    if (genesisBib) return genesisBib;
    const workmaxPants = alignWorkmaxPants(guide, sizes, productHandle);
    if (workmaxPants) return workmaxPants;
    if (guide.gridId === 'SG-38' && (sizes.length !== Object.keys(eapu03Sizes).length || sizes.some((size) => !eapu03Sizes[sizeKey(size)]))) return guide;
    const alignedRows = sizes.map((size) => {
      const chartSize = guide.gridId === 'SG-38' ? eapu03Sizes[sizeKey(size)] : size;
      const row = guide.rows.find((candidate) => sizeKey(candidate.size) === sizeKey(chartSize));
      return row && { ...row, size };
    });
    if (alignedRows.every(Boolean)) return { ...guide, rows: alignedRows };
    // Match numeric waist groups and their inseam measurements, not row order.
    return alignNumericGuide(guide, sizes) || guide;
  };

  const loadCatalog = () => {
    if (catalogPromise) return catalogPromise;
    const url = dialog.dataset.yxSizeGuideCatalogUrl;
    catalogPromise = url
      ? fetch(url, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`Size guide catalog request failed with ${response.status}.`);
        return response.json();
      }).catch((error) => {
        console.warn('YURINOX size guide catalog could not be loaded.', error);
        return null;
      })
      : Promise.resolve(null);
    return catalogPromise;
  };

  const formatMeasurement = (value) => {
    const text = String(value || '').trim();
    if (!text || text === '—') return text;

    return text.split(/\s*[–-]\s*/).map((part) => {
      const feet = part.match(/^(\d+)[’'](\d+)$/);
      if (feet) return `${(Number(feet[1]) * 12) + Number(feet[2])}″`;
      if (/^\d+(?:\.\d+)?["″]?$/.test(part)) return `${part.replace(/["″]$/, '')}″`;
      return part;
    }).join('–');
  };

  const localizedColumnLabel = (label) => {
    if (!isSpanish) return label;
    const translations = {
      size: 'Talla / Size',
      'brand size': 'Talla / Brand size',
      chest: 'Pecho / Chest',
      waist: 'Cintura / Waist',
      hips: 'Caderas / Hips',
      'arm length': 'Largo de brazo / Arm length',
      'sleeve length': 'Largo de manga / Sleeve length',
      height: 'Altura / Height',
      'back length': 'Largo de espalda / Back length',
      length: 'Largo / Length',
      'chest width': 'Ancho de pecho / Chest width',
      thigh: 'Muslo / Thigh',
      inseam: 'Entrepierna / Inseam',
      'us size': 'Talla EE. UU. / US size',
      'uk size': 'Talla Reino Unido / UK size',
      'eu size': 'Talla UE / EU size',
    };
    return translations[String(label || '').toLowerCase()] || label;
  };

  const localizedSizeValue = (value) => {
    if (!isSpanish) return value;
    return String(value || '').replace(/Extra Tall/gi, 'Extra alto').replace(/Tall/gi, 'Alto');
  };

  const resolveGuide = async (trigger) => {
    const embeddedGuide = readEmbeddedGuide(trigger);
    const sizes = readVariantSizes(trigger);
    const scope = trigger.closest('[data-yx-size-guide-scope]');
    const productHandle = scope?.dataset.yxSizeGuideHandle;
    // Progress has a newer owner-supplied chart than its Shopify metaobject.
    // Keep the image from the metaobject, but use the corrected theme data for measurements.
    if (productHandle === 'yurinox-progress-mens-ripstop-carpenter-work-pants' && embeddedGuide?.gridId === 'SG-26') {
      const catalog = await loadCatalog();
      const correctedGuide = catalog?.guides?.find((guide) => guide.gridId === 'SG-26');
      if (correctedGuide) return alignGuideToVariants({ ...embeddedGuide, ...correctedGuide, illustration: embeddedGuide.illustration }, sizes, productHandle);
    }
    if (embeddedGuide?.gridId) return alignGuideToVariants(embeddedGuide, sizes, productHandle);

    if (productHandle) {
      const catalog = await loadCatalog();
      const mapping = catalog?.products?.find((product) => product.liveHandle === productHandle || product.handle === productHandle);
      const guide = mapping && catalog?.guides?.find((item) => item.gridId === mapping.gridId);
      if (guide) return alignGuideToVariants(guide, sizes, productHandle);
    }

    return embeddedGuide;
  };

  const renderGuide = (guide) => {
    const columns = Array.isArray(guide?.columns) ? guide.columns.filter((column) => column?.key && column?.label) : [];
    const rows = Array.isArray(guide?.rows) ? guide.rows : [];
    if ((!columns.length || !rows.length) && guide?.unavailable) {
      if (tableScroll) tableScroll.hidden = true;
      if (unavailable) unavailable.hidden = false;
      if (illustration) illustration.hidden = true;
      return true;
    }
    if (!columns.length || !rows.length || !table || !tableHead || !tableBody) return false;

    if (tableScroll) tableScroll.hidden = false;
    if (unavailable) unavailable.hidden = true;

    const headRow = document.createElement('tr');
    columns.forEach((column) => {
      const cell = document.createElement('th');
      cell.scope = 'col';
      cell.textContent = localizedColumnLabel(column.label);
      headRow.append(cell);
    });

    const bodyRows = document.createDocumentFragment();
    rows.forEach((row) => {
      const tableRow = document.createElement('tr');
      columns.forEach((column, index) => {
        const cell = document.createElement(index === 0 ? 'th' : 'td');
        if (index === 0) cell.scope = 'row';
        const value = row[column.key] || '—';
        cell.textContent = index === 0 ? localizedSizeValue(value) : (guide.valueFormat === 'raw' ? value : formatMeasurement(value));
        tableRow.append(cell);
      });
      bodyRows.append(tableRow);
    });

    tableHead.replaceChildren(headRow);
    tableBody.replaceChildren(bodyRows);

    const pantsIllustrationUrl = pantsGuideIds.has(guide.gridId) ? dialog.dataset.yxPantsGuideUrl : '';
    const bibOverallsIllustrationUrl = bibOverallsGuideIds.has(guide.gridId)
      ? dialog.dataset.yxBibOverallsGuideUrl
      : '';
    const topsIllustrationUrl = topsGuideIds.has(guide.gridId) ? dialog.dataset.yxTopsGuideUrl : '';
    const vestsIllustrationUrl = vestsGuideIds.has(guide.gridId) ? dialog.dataset.yxVestsGuideUrl : '';
    const jacketsIllustrationUrl = jacketsGuideIds.has(guide.gridId) ? dialog.dataset.yxJacketsGuideUrl : '';
    const rainSuitIllustrationUrl = rainSuitGuideIds.has(guide.gridId) ? dialog.dataset.yxRainSuitGuideUrl : '';
    const guideIllustration = guide.illustration?.src
      ? guide.illustration
      : pantsIllustrationUrl
        ? {
          src: pantsIllustrationUrl,
          alt: isSpanish ? 'Guía de medidas para pantalones' : 'Pants measurement guide',
          width: 1164,
          height: 1351,
        }
        : bibOverallsIllustrationUrl
          ? {
            src: bibOverallsIllustrationUrl,
            alt: isSpanish ? 'Guía de medidas para petos' : 'Bib overalls measurement guide',
            width: 1164,
            height: 1351,
          }
          : topsIllustrationUrl
            ? {
              src: topsIllustrationUrl,
              alt: isSpanish ? 'Guía de medidas para camisetas, polos y tops médicos' : 'Shirts, polos, and medical tops measurement guide',
              width: 1164,
              height: 1351,
            }
            : vestsIllustrationUrl
              ? {
                src: vestsIllustrationUrl,
                alt: isSpanish ? 'Guía de medidas para chalecos de trabajo' : 'Work vests measurement guide',
                width: 1164,
                height: 1351,
              }
              : jacketsIllustrationUrl
                ? {
                  src: jacketsIllustrationUrl,
                  alt: isSpanish ? 'Guía de medidas para chaquetas y sudaderas de trabajo' : 'Work jackets, hoodies, and sweatshirts measurement guide',
                  width: 1164,
                  height: 1351,
                }
                : rainSuitIllustrationUrl
                  ? {
                    src: rainSuitIllustrationUrl,
                    alt: isSpanish ? 'Guía de medidas para chaqueta y pantalón de lluvia' : 'Rain suit jacket and pants measurement guide',
                    width: 1164,
                    height: 1351,
                  }
                  : null;

    if (guideIllustration?.src && illustration && illustrationImage) {
      illustrationImage.src = guideIllustration.src;
      illustrationImage.alt = guideIllustration.alt || (isSpanish ? 'Guía de medidas del producto' : `${guide.name || 'Product'} measurement guide`);
      illustrationImage.width = Number(guideIllustration.width) || 1200;
      illustrationImage.height = Number(guideIllustration.height) || 1200;
      illustration.hidden = false;
    } else if (illustration && illustrationImage) {
      illustration.hidden = true;
      illustrationImage.removeAttribute('src');
      illustrationImage.alt = '';
    }

    return true;
  };

  const open = async (trigger) => {
    if (!isSupportedViewport() || dialog.open) return;
    const guide = await resolveGuide(trigger);
    if (dialog.open) return;
    if (!guide || !renderGuide(guide)) return;
    opener = trigger;
    document.documentElement.classList.add('yx-size-guide-open');
    dialog.showModal();
    window.requestAnimationFrame(() => {
      if (mobileMedia.matches) {
        dialog.focus();
      } else {
        dialog.querySelector('[data-yx-size-guide-close]')?.focus();
      }
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-yx-size-guide-trigger]');
    if (trigger && isSupportedViewport()) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (event.target.closest('[data-yx-size-guide-close]')) {
      event.preventDefault();
      close();
      return;
    }

    if (event.target === dialog) close();
  });

  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('yx-size-guide-open');
    opener?.focus();
    opener = null;
  });

  const onViewportChange = () => {
    syncTriggerAccessibility();
    if (!isSupportedViewport()) close();
  };

  desktopMedia.addEventListener('change', onViewportChange);
  tabletMedia.addEventListener('change', onViewportChange);
  mobileMedia.addEventListener('change', onViewportChange);

  syncTriggerAccessibility();

  new MutationObserver((entries) => {
    entries.forEach((entry) => entry.addedNodes.forEach(syncAddedTriggers));
  }).observe(document.body, { childList: true, subtree: true });
})();
